export default __webpack_public_path__ + "static/media/1.3ca58b74.webp";